/* eslint-disable */
import React from 'react'
import cls from './seoIndex.module.sass'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { openMenu } from '../../../store/common/commonSlice'
import { RootState } from '../../../store/rootReducer'

const FrSeoInfo = () => {
    const dispatch = useDispatch()
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    return (
        <div className={cls["page_desc"]}>
            <p>
                Je suis Bob le créateur de ce site <strong>libertin</strong>, je suis heureux de vous accueillir sur Bob
                Voyeur, un site pour les <strong>amateurs</strong> avec un contenu 100% <strong>amateur</strong>. Bob
                Voyeur est un site pour <strong>adultes</strong> dédié à l'exhibition et au voyeurisme. Depuis plus de 6
                ans des milliers de <strong>couples amateurs</strong>, de femmes amatrices et d'hommes libertins me font
                confiance et partagent leurs <strong>vidéos coquines</strong> et leurs <strong>photos érotiques</strong>{' '}
                avec des millions de voyeurs aimant le sexe sous toutes ses formes. La communauté Bob Voyeur est la plus
                grande communauté libertine de l'Internet en France, le rendez-vous quotidien de milliers de coquins
                aimant <strong>l'exhibition</strong>, <strong>le libertinage</strong>, <strong>le voyeurisme</strong>,{' '}
                <strong>le mélangisme</strong> et même <strong>l'échangisme</strong>. Chaque jour je reçois des dizaines
                de contributions d'amateurs qui me sont envoyées par des <strong>couples libertins</strong>, des{' '}
                <strong>hommes coquins</strong> ou des <strong>femmes sexy</strong>
                {' '}et je les publie aussitôt pour le plus grand plaisir des voyeurs. Les contributions photos et vidéos
                sont classées dans les différentes sections du site et un très grande nombre est en{' '}
                <strong>accès gratuit</strong>.
            </p>
            <p>
                Les <strong>photos</strong> de charme SOFT ainsi que les <strong>vidéos</strong> de moins de 30 secondes
                sont publiées dans la section <strong>gratuite</strong> de Bob Voyeur. Les photos HOT, les vidéos
                longues de plus de 30 secondes, les contributions à thèmes et toutes les archives depuis la création du
                site sont réservés aux membres Premium.
            </p>
            <p>
                Vous pouvez vous aussi partager vos <strong>photos coquines</strong> et vos{' '}
                <strong>vidéos érotiques</strong> avec tous les <strong>amateurs libertins</strong> de la communauté de
                Bob. L'inscription est gratuite. En quelques minutes vous allez pouvoir télécharger anonymement votre
                contribution sur la page "<Link onClick={(event) => {if (!loggedIn) {
                event.preventDefault()
                dispatch(openMenu())
            }}} to={`/membre/submit`}>Envoyez vos photos</Link>" et joindre le texte de votre
                annonce qui vous permettra de rentrer aussitôt en contact avec des milliers de couples, d'hommes et de
                femmes qui auront apprécié votre contribution et ne manquerons pas de vous le faire savoir ;-)
            </p>
            <p>
                Le plus important pour moi est que toutes les <strong>photos de charme</strong> et les{' '}
                <strong>vidéos érotiques</strong> publiées sur Bob Voyeur soient authentiques et réellement
                <strong>amateurs</strong>. La page "<a href="/femmes-et-couples-certifies/">Couples certifiés</a>"
                regroupe plusieurs centaines d'amateurs qui m'ont apporté la preuve de leur authenticité en m'envoyant
                une photo certifiée. Les photos ou les vidéos volées, de mauvaise qualité ou manquant d'esthétisme ne
                sont pas publiées. Seules les <strong>contributions érotiques</strong> de qualité sont mises en ligne
                tous les jours et les plus sexy sont choisies pour paraître sur la page "
                <a href="/les-meilleures-photos/">Les meilleurs photos</a>".
            </p>
            <p>
                Un service de messagerie gratuite vous permet d'envoyer un message aux <strong>amateurs</strong> qui ont
                publié leur annonce <strong>photo</strong> ou <strong>vidéo</strong> de sexe. Il suffit de vous inscrire
                gratuitement pour envoyer un message et laisser vos commentaires aux couples, aux femmes et aux hommes
                de votre choix. Vous pouvez joindre vos photos de charme personnelles à votre message pour vous
                présenter et commencer à échanger vos propres <strong>photos coquines</strong> et vos{' '}
                <strong>vidéos érotiques</strong>
                avec eux.
            </p>
            <p>
                Quelque soit votre recherche, votre demande, votre envie ou votre fantasme vous allez pouvoir rencontrer
                les couples, les hommes et les femmes qui auront quelque chose à partager avec vous. La communauté Bob
                Voyeur est dédiée à tous les adultes coquins, les libertins et regroupe toutes les tendances:{' '}
                <strong>le libertinage</strong>, <strong>l'échangisme</strong>, <strong>le mélangisme</strong>,{' '}
                <strong>le voyeurisme</strong> et <strong>l'exhibition</strong>. Vous pouvez tout partager, vivre vos
                fantasme érotiques et faire des rencontres avec des couples mélangistes et échangistes.
            </p>
            <p>
                Bienvenue dans ce lieux culte du libertinage, du charme, de l'érotisme, du fantasme, de l'échange et du
                porno.
            </p>
            <p>
                Si vous êtes un homme, que vous aimez vous exhiber ou que vous recherchez plus des hommes sexy que des
                femmes amatrices ou des couples, vous devez visiter la version <strong>gay et travesti</strong> de
                bobvoyeur. Mon site{' '}
                <a href="http://www.bob4men.com/" target="_blank" rel="noreferrer">
                    www.bob4men.com
                </a>{' '}
                est réservé à <strong>l'exhibition adulte au masculin</strong> ;-)
            </p>
            <p>
                Et si pour finir vous voulez aller encore plus loin dans l'exhibition et le voyeurisme, je vous invite à
                découvrir{' '}
                <a href="http://www.bobtv.fr/" target="_blank" rel="noreferrer">
                    www.bobTV.fr
                </a>{' '}
                le plus grand <strong>tchat webcam pour adultes</strong> en France. Je vous y accueille 24 heures sur 24
                et 7 jours sur 7 sur la plus grande plateforme de salles de tchat en France. bobTV est une nouvelle
                façon de parler de sexe, de s'exhiber et de <strong>rencontrer des couples libertins</strong> faisant
                l'amour devant leur webcam et pratiquant l'échangisme.
            </p>
            <p>Bonne visite coquine à tous les voyeurs, partagez vos fantasmes et amusez vous bien ;-)</p>
            <p>Bob</p>
        </div>
    )
}

export default FrSeoInfo
